import React from 'react'
import styles from "./styles.module.css";

function MostRecentData({ record }) {
    return (
        <section className={styles.containerMostRecentData}>
            {/* Row 1: Sale */}
            <div className={styles.gridItem}>
                <span className={styles.spanTitle}>
                    Most recent sale status
                </span>
                <span className={styles.spanTypeValue}>
                    {record?.mostRecentStatus ? record.mostRecentStatus : "N/A"}
                </span>
            </div>

            <div className={styles.gridItem}>
                <span className={styles.spanTitle}>
                    Most recent sale list price
                </span>
                <span className={styles.spanTypeValue}>
                    {record?.mostRecentSaleListPriceAmount
                        ? `$${record.mostRecentSaleListPriceAmount.toLocaleString()}`
                        : "N/A"}
                </span>
            </div>

            <div className={styles.gridItem}>
                <span className={styles.spanTitle}>
                    Most recent sold price
                </span>
                <span className={styles.spanTypeValue}>
                    {record?.mostRecentSoldPriceAmount
                        ? `$${record.mostRecentSoldPriceAmount.toLocaleString()}`
                        : "N/A"}
                </span>
            </div>

            {/* Row 2: Rental */}
            <div className={styles.gridItem}>
                <span className={styles.spanTitle}>
                    Most recent rental status
                </span>
                <span className={styles.spanTypeValue}>
                    {record?.mostRecentRentalStatus ? record.mostRecentRentalStatus : "N/A"}
                </span>
            </div>

            <div className={styles.gridItem}>
                <span className={styles.spanTitle}>
                    Most recent rental list price
                </span>
                <span className={styles.spanTypeValue}>
                    {record?.mostRecentRentalListPriceAmount
                        ? `$${record.mostRecentRentalListPriceAmount.toLocaleString()}`
                        : "N/A"}
                </span>
            </div>
        </section>
    )
}

export default MostRecentData
